var _style, _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnLights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    height: "50px",
    width: "50px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#010101;}\r\n\t.st2{display:inline;fill:#FFFFFF;}\r\n\t.st3{stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 0.8,
    className: "st1",
    width: 19.8,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 0.8,
    className: "st1",
    width: 19.8,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 2.7,
    className: "st2",
    width: 16.5,
    height: 20.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 2.7,
    className: "st2",
    width: 16.5,
    height: 20.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25.7,
    className: "st2",
    width: 6.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 25.7,
    className: "st2",
    width: 6.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "3.9,25.7 9.6,25.7 15.8,31.9 23.7,31.9 23.7,34.2 14.9,34.2 8.5,27.8 3.9,27.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "3.9,32.6 9.7,32.6 15.9,38.8 23.7,38.8 23.7,41 14.9,41 8.5,34.6 3.9,34.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "44.5,32.6 38.8,32.6 32.6,38.8 24.7,38.8 24.7,41 33.5,41 39.9,34.6 44.5,34.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "44.5,25.7 38.8,25.7 32.6,31.9 24.7,31.9 24.7,34.2 33.5,34.2 39.9,27.8 44.5,27.8  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.4,15.9v3.9h6c0,0,1-0.2,1.3,1.1v9.9c0,0,0,0.9-1.2,1.1h-6v3.8c0,0-0.5,1.6-2.2,0.7l-9.7-9.9 c0,0-0.7-0.8,0.3-1.8l9.5-9.4C11.3,15.2,12.9,14.3,13.4,15.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.3,25.7L11,19v2.3c0,0,0.3,0.9,1.2,0.9h6v7.3H12c0,0-0.9,0.2-1,1v2.1L4.3,25.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.1,15.9v3.9h-6c0,0-1-0.2-1.3,1.1v9.9c0,0,0,0.9,1.2,1.1h6v3.8c0,0,0.5,1.6,2.2,0.7l9.6-9.9 c0,0,0.7-0.8-0.3-1.8l-9.5-9.4C37.3,15.2,35.7,14.3,35.1,15.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M44.3,25.7L37.6,19v2.3c0,0-0.3,0.9-1.2,0.9h-6v7.3h6.2c0,0,0.9,0.2,1,1v2.1L44.3,25.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnLights);
export default __webpack_public_path__ + "static/media/turn-lights.6c42a8caccdd9698cedf50e7a7f7026c.svg";
export { ForwardRef as ReactComponent };